





























import { Contact } from "@/api/models";
import { SubmissionState } from "@/store/types";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { notEmptyString } from "../../api/validators";

@Component({
  components: {},
  filters: {},
})
export default class ContactField extends Vue {
  @Prop({ default: "Contact" }) label: string;
  @Prop({ default: () => new Contact() }) contact: Contact;
  @Prop({ default: 0 }) index: number;
  @Prop({ default: false }) showNotes: boolean;
  @State("submission") submission: SubmissionState;

  type = "email";
  identifier = "";
  notes = "";

  fieldType = "email";

  switching = false;

  types = [
    {
      key: "email",
      name: "Email",
    },
    {
      key: "phone",
      name: "Phone",
    },
  ];

  created() {
    this.sync();
  }

  sync() {
    if (notEmptyString(this.contact.type)) {
      this.type = this.contact.type;
      this.assignFieldType();
    }
    this.identifier = this.contact.identifier;
    this.notes = this.contact.notes;
  }

  update() {
    const contact = new Contact({
      type: this.type,
      identifier: this.identifier,
      notes: this.notes,
    });
    const refField = this.submission.contacts;
    if (refField instanceof Array) {
      if (this.index >= 0) {
        if (this.index < refField.length) {
          refField[this.index] = contact;
        } else {
          refField.push(contact);
        }
      }
    }
  }

  assignFieldType() {
    this.fieldType = this.matchFieldType();
    setTimeout(() => {
      this.switching = false;
    }, 125);
  }

  matchFieldType() {
    switch (this.type) {
      case "url":
        return "url";
      case "phone":
        return "tel";
      default:
        return "email";
    }
  }

  get identifierPlaceholder() {
    switch (this.type) {
      case "url":
        return "https://example.net";
      case "phone":
        return "0123456789";
      default:
        return "email@provider.net";
    }
  }

  deleteItem() {
    const refField = this.submission.contacts;
    if (refField instanceof Array && this.index < refField.length) {
      refField.splice(this.index, 1);
    }
  }

  get wrapperClasses() {
    return [this.showNotes ? "has-notes" : "twin-fields"];
  }

  @Watch("type")
  changeType() {
    this.update();
    this.switching = true;
    setTimeout(this.assignFieldType, 250);
  }
  @Watch("identifier")
  changeIdentifier() {
    this.update();
  }
  @Watch("notes")
  changeNotes() {
    this.update();
  }
}
